import React, { useEffect } from 'react';
import { Box, TableBody } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  MainContainer,
  HeaderContainer,
  PageTitle,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
} from './styles';
import { useBreadcrumb } from '../../../context/BreadcrumbContext';
import { useSidebar } from '../../../context/SidebarContext';

const MASTER_DATA_LINKS = [
  { name: 'Role', path: '/master-data/roles', description: 'Manage user roles and permissions' },
  { name: 'Cancellation Reasons', path: '/master-data/cancellation-reasons', description: 'Manage reasons for cancellations' },
  { name: 'Facility Types', path: '/master-data/facility-types', description: 'Manage different types of facilities' },
  { name: 'Qualifications', path: '/master-data/qualifications', description: 'Manage worker qualifications' },
  { name: 'Document Types', path: '/master-data/document-types', description: 'Manage required document types' },
  { name: 'Designations', path: '/master-data/designations', description: 'Manage job designations' },
  { name: 'Role Doc Mapping', path: '/master-data/role-doc-mapping', description: 'Map documents to roles' },
  { name: 'Facility Type Doc Mapping', path: '/master-data/facility-type-doc-mapping', description: 'Map documents to facility types' },
  { name: 'Banks', path: '/master-data/banks', description: 'Manage bank information' },
  { name: 'Config', path: '/master-data/config', description: 'System configurations' },
  { name: 'Bank Forms', path: '/master-data/bank-forms', description: 'Manage bank forms' },
  { name: 'Custom Forms', path: '/master-data/custom-forms', description: 'Create and manage custom forms' },
];

const MasterDataDashboard: React.FC = () => {
  const { setActivePage } = useSidebar();
  const { setPath, setIsShow } = useBreadcrumb();
  const navigate = useNavigate();

  useEffect(() => {
    setActivePage('settings'); // Keep settings expanding
    setPath([
      { title: 'Settings', path: '/master-data' },
      { title: 'Master Data', path: '' },
    ]);
    setIsShow(true);
  }, [setActivePage, setPath, setIsShow]);

  const handleRowClick = (path: string) => {
    navigate(path);
  };

  return (
    <Box>
      <MainContainer>
        <HeaderContainer>
          <PageTitle variant="h6">Master Data</PageTitle>
        </HeaderContainer>

        <StyledTableContainer>
          <StyledTable>
            <StyledTableHead>
              <StyledTableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell align="right">Action</StyledTableCell>
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {MASTER_DATA_LINKS.map((item, index) => (
                <StyledTableRow key={index} onClick={() => handleRowClick(item.path)}>
                  <StyledTableCell>{index + 1}</StyledTableCell>
                  <StyledTableCell sx={{ fontWeight: 500 }}>{item.name}</StyledTableCell>
                  <StyledTableCell>{item.description}</StyledTableCell>
                  <StyledTableCell align="right">
                    <ArrowForwardIcon fontSize="small" color="action" />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </MainContainer>
    </Box>
  );
};

export default MasterDataDashboard;
